import { DEFAULT_FONT_FAMILY } from '../theme/fontConstants';
export function getFontWithFallback(fontFamily, fallbackFont) {
  return `${fontFamily}, ${fallbackFont || DEFAULT_FONT_FAMILY}`;
}